import {
  makeStyles,
  createStyles,
  Theme
} from "@material-ui/core/styles"
import { GREY_COLOR } from "~/constants/colors"
import { TYPOGRAPHY } from "~/constants/typography"

export default makeStyles((theme: Theme) => createStyles({
    mainContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 80,
      [theme.breakpoints.down('md')]: {
        marginTop: 53
      },
      [theme.breakpoints.down('md')]: {
        marginTop: 32
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: -16,
        marginRight: -16
      }
    },
    itemsContainer: {
      width: '83%',
      backgroundColor: GREY_COLOR.Grey6,
      padding: '64px 80px 24px',
      display: 'flex',
      boxSizing: 'border-box',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
      [theme.breakpoints.down('md')]: {
        width: '82%',
        padding: '40px 56px 15px'
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: '71px 24px 15px'
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: '48px 16px 64px'
      }
    },
    item :{
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      '&:last-of-type': {
        marginLeft: 40
      },
      [theme.breakpoints.down('sm')]: {
        '&:last-of-type': {
          marginLeft: 16
        }
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        '&:last-of-type': {
          marginLeft: 0
        }
      }
    },
    icon: {
      width: 22,
      height: 22,
      objectFit: 'contain',
      [theme.breakpoints.down('md')]: {
        width: 18,
        height: 18
      }
    },
    advantageText: {
      ...TYPOGRAPHY.h6,
      lineHeight: '26px',
      color: GREY_COLOR.Grey1,
      maxWidth: 388,
      display: 'block',
      marginLeft: 23,
      [theme.breakpoints.down('md')]: {
        marginLeft: 12
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: 277,
      }
    },
    advantageContainer: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: 30,
      [theme.breakpoints.down('md')]: {
        marginBottom: 26
      }
    }
}));
